<template>
  <v-row justify="center">
    <v-dialog v-model="dialogForm" persistent max-width="800px">
      <v-card>
        <v-toolbar class="grey lighten-4" flat>
          <v-toolbar-title class="text-h6">{{ formTitle }}</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-form v-model="valid" lazy-validation @submit.prevent="submit" ref="form">
          <v-card-text class="pb-0">
            <v-container fluid>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    label="Nome"
                    :error-messages="errors.nome"
                    v-model="formData.nome"
                    :counter="300"
                    :rules="rules.nome"
                    outlined
                    dense
                    class="pa-0"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-autocomplete
                    label="Pessoa"
                    v-model="formData.cgm_id"
                    :items="itemsAutoComplete"
                    :loading="isloadingAutoComplete"
                    :search-input.sync="searchAutoComplete"
                    outlined
                    hide-no-data
                    hide-selected
                    item-text="nome_documento"
                    item-value="id"
                    placeholder="Digite no mínimo 3 caracteres"
                    clearable
                    dense
                    :rules="rules.nome"
                    :error-messages="errors.cgm_id"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="6">
                  <v-autocomplete
                    label="Estados"
                    v-model="formData.estado"
                    :items="estados"
                    :search-input.sync="searchEstadosAutoComplete"
                    outlined
                    hide-no-data
                    hide-selected
                    item-text="nome"
                    item-value="id"
                    :aria-autocomplete="false"
                    clearable
                    dense
                    :rules="rules.estado"
                    :error-messages="errors.estado"
                    @change="getCidades"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col class="py-0" cols="6">
                  <v-autocomplete
                    label="Cidades"
                    v-model="formData.cidade_id"
                    :items="cidades"
                    :search-input.sync="searchCidadesAutoComplete"
                    outlined
                    hide-no-data
                    hide-selected
                    item-text="nome"
                    item-value="id"
                    :aria-autocomplete="false"
                    clearable
                    dense
                    :rules="rules.cidade_id"
                    :loading="isloadingCidades"
                    :error-messages="errors.cidade_id"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-if="!isShowLogo">
                  <v-file-input
                    v-model="formData.logo"
                    accept="image/*"
                    label="Logo"
                    dense
                    clearable
                    outlined
                    show-size
                    :error-messages="errors.logo"
                  >
                  </v-file-input>
                </v-col>
                <v-col v-if="!isShowBrasao">
                  <v-file-input
                    v-model="formData.brasao"
                    accept="image/*"
                    label="Brasão"
                    outlined
                    clearable
                    dense
                    show-size
                    :error-messages="errors.brasao"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
              <v-row v-if="isShowImages">
                <v-col cols="6" v-if="isShowLogo">
                  <v-card
                    class="mx-auto"
                    max-width="160"
                    outlined
                  >
                    <v-img
                      class="white--text align-end"
                      height="160px"
                      :src="data.logo"
                    >
                      <v-card-title>Logo</v-card-title>
                    </v-img>
                    <v-divider></v-divider>
                    <v-card-actions style="text-align: center; display:block">
                      <v-btn color="error"
                             depressed
                             @click="destroyFileConfirm('logo')">
                        <v-icon small left>mdi-delete</v-icon>
                        Excluir
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <v-col cols="6" v-if="isShowBrasao">
                  <v-card
                    class="mx-auto"
                    max-width="160"
                    outlined
                  >
                    <v-img
                      class="white--text align-end"
                      height="160px"
                      :src="data.brasao"
                    >
                      <v-card-title>Brasão</v-card-title>
                    </v-img>
                    <v-divider></v-divider>
                    <v-card-actions style="text-align: center; display:block">
                      <v-btn color="error"
                             depressed
                             @click="destroyFileConfirm('brasao')">
                        <v-icon small left>mdi-delete</v-icon>
                        Excluir
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn color="red" dark
                   depressed
                   @click="toggleForm">
              <v-icon small left>mdi-close</v-icon>
              Fechar
            </v-btn>
            <v-btn
              :disabled="!valid"
              depressed
              :loading="isloadingSubmit"
              color="green" dark
              type="submit">
              <v-icon small left>mdi-send</v-icon>
              Salvar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { max, required } from '@/services/util/validate';
import toastMessage, { confirmDestroyAlert, toastResponseError } from '@/services/util/alertService';
import estadoHttp from '@/services/http/resources/configuracao/estadoHttp';
import cidadeHttp from '@/services/http/resources/configuracao/cidadeHttp';
import pessoaHttp from '@/services/http/resources/configuracao/pessoaHttp';

export default {
  name: 'ModalForm',
  data: () => ({
    valid: true,
    estados: [],
    cidades: [],
    searchEstadosAutoComplete: '',
    searchCidadesAutoComplete: '',
    formData: {
      id: '',
      nome: '',
      logo: null,
      brasao: null,
      cgm_id: '',
      cidade_id: '',
      estado: '',
    },
    formDataDefault: {
      id: '',
      nome: '',
      logo: null,
      brasao: null,
      cgm_id: '',
      cidade_id: '',
      estado: '',
    },
    rules: {
      nome: [
        required,
        (value) => max(value, 300),
      ],
      cgm_id: [required],
      cidade_id: [required],
    },
    errors: {
      nome: [],
      perfil_id: [],
      logo: [],
      brasao: [],
      cidade_id: [],
    },
    isloadingSubmit: false,
    isloadingAutoComplete: false,
    isloadingCidades: false,
    itemsAutoComplete: [],
    searchAutoComplete: '',
    paramsSearch: {
      page: 1,
      sortBy: [],
      sortDesc: null,
      itemsPerPage: -1,
      searchBy: null,
    },
  }),
  computed: {
    ...mapState('instituicao', ['dataIndex', 'data', 'dialogForm']),
    formTitle() {
      return this.dataIndex === -1 ? 'Nova Instituição' : 'Editar Instituição';
    },
    isShowLogo() {
      return !!this.data.logo;
    },
    isShowBrasao() {
      return !!this.data.brasao;
    },
    isShowImages() {
      return !!this.data.logo || !!this.data.brasao;
    },
  },
  created() {
    estadoHttp.list().then(({ data: { data } }) => {
      this.estados = data;
    });
  },
  methods: {
    ...mapActions('instituicao', [
      'toggleForm',
      'store',
      'update',
      'updateFile',
      'setDataIndex',
      'clearData',
      'destroyFile',
    ]),
    getCidades() {
      this.resetCidadesAutoComplete();
      if (!this.formData.estado) return;
      this.isloadingCidades = true;
      cidadeHttp.listCidades(this.formData.estado)
        .then(({ data: { data } }) => {
          this.cidades = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar cidades'))
        .finally(() => {
          this.isloadingCidades = false;
        });
    },
    resetEstadosAutoComplete() {
      this.formData.estado = '';
      this.searchEstadosAutoComplete = null;
    },
    resetCidadesAutoComplete() {
      this.cidades = [];
      this.formData.cidade_id = '';
      this.searchCidadesAutoComplete = null;
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.isloadingSubmit = true;
        const actionHttp = (this.dataIndex === -1)
          ? this.store(this.getFormData()) : this.updateFile(this.getFormData());
        actionHttp.then(() => {
          toastMessage.successSave('Instituição salva com sucesso');
          this.resetValidation();
        })
          .catch(({ response }) => {
            if (response.status === 422) {
              const { errors } = response.data;
              Object.entries(errors)
                .forEach(([index, value]) => {
                  this.errors[index].push(value.toString());
                  toastMessage.errorValidation();
                });
            } else {
              toastMessage.errorSave('Erro ao salvar instituição');
            }
          })
          .finally(() => {
            this.isloadingSubmit = false;
          });
      }
    },
    destroyFileConfirm(item) {
      confirmDestroyAlert(item)
        .then((result) => {
          if (result.value) {
            this.destroyFile(item)
              .then(() => toastMessage.successDestroy('Imagem excluída com sucesso'))
              .catch(() => toastMessage.errorDestroy('Erro ao excluir imagem'));
          }
        });
    },
    // upload file
    getFormData() {
      const formData = new FormData();
      Object.entries(this.formDataDefault)
        .forEach(([key]) => {
          if ((key === 'logo') || (key === 'brasao')) {
            if (this.formData[key]) {
              formData.append(key, this.formData[key]);
            }
          } else {
            formData.append(key, this.formData[key]);
          }
        });
      return formData;
    },
    openDialogForm() {
      this.resetValidation();
      this.resetAutoComplete();
      if (this.dataIndex > -1) {
        Object.entries(this.formDataDefault)
          .forEach(([key]) => {
            if (key === 'cidade_id') {
              cidadeHttp.find(this.data[key]).then(({ data: { data } }) => {
                this.formData.estado = data.estado_id;
                this.getCidades();
                this.formData[key] = this.data[key];
              });
            } else if (key === 'cgm_id') {
              this.formData[key] = this.data.cgm.id;
            } else if (key === 'brasao' || key === 'logo') {
              this.formData[key] = null;
            } else {
              this.formData[key] = this.data[key];
            }
          });
        this.itemsAutoComplete.push(this.data.cgm);
      }
    },
    closeDialogForm() {
      setTimeout(() => {
        Object.entries(this.formDataDefault)
          .forEach(([key]) => {
            this.formData[key] = this.formDataDefault[key];
          });
        this.resetValidation();
        this.resetAutoComplete();
        this.resetEstadosAutoComplete();
        this.resetCidadesAutoComplete();
        this.clearData();
        this.setDataIndex(-1);
      }, 300);
    },
    loadAutoComplete(value, resourceHttp, id) {
      const index = (this.itemsAutoComplete.map((x) => x.id)
        .indexOf(id));
      if (index > -1) return;
      this.isloadingAutoComplete = true;
      resourceHttp.listPessoaJuridica(value)
        .then(({ data }) => {
          this.itemsAutoComplete = data.data;
        })
        .catch((error) => toastResponseError(error))
        .then(() => {
          this.isloadingAutoComplete = false;
        });
    },
    resetAutoComplete() {
      this.itemsAutoComplete = [];
      this.searchAutoComplete = null;
    },
  },
  watch: {
    dialogForm(value) {
      if (value) {
        this.openDialogForm();
      } else {
        this.closeDialogForm();
      }
    },
    'formData.nome': function () {
      this.errors.nome = [];
    },
    'formData.logo': function () {
      this.errors.logo = [];
    },
    'formData.brasao': function () {
      this.errors.brasao = [];
    },
    'formData.cgm_id': function () {
      this.errors.cgm_id = [];
    },
    'formData.cidade_id': function () {
      this.errors.cidade_id = [];
    },
    searchAutoComplete(value) {
      if (!value) return;
      if (value.length < 3) return;
      if (this.isloadingAutoComplete) return;
      this.loadAutoComplete(value, pessoaHttp, this.formData.cgm_id);
    },
  },
};
</script>

<style></style>
